import { setLanguageToPhoible } from "../world/languageToPhoibleId";
import { segmentsByLanguage, setSegmentsByLanguage } from "../world/segmentsByLanguage";
import { fetchJson } from "./fetchJson";

const segmentsFile = 'segmentsByLanguage.json';
const languageToPhoible = 'languageToPhoible.json';

/** load all world phoneme data files */
export async function loadWorldData() {
  const entryCount = Object.getOwnPropertyNames(segmentsByLanguage).length;
  if (entryCount > 0) {
    // data already loaded
    return new Promise((resolve) => resolve('skipped'));
  }

  const p1 = fetchJson(segmentsFile, loadEvents);
  const p2 = fetchJson(languageToPhoible, loadEvents);
  return Promise.all([p1, p2]);
}

const loadEvents = {
  gotJson(fileName: string, json: any) {
    switch (fileName) {
      case segmentsFile:
        setSegmentsByLanguage(json as Record<string, string>);
        break;
      case languageToPhoible:
        setLanguageToPhoible(json as Record<string, number>);
        break;
    }
  },
  gotError(fileName: string, message: string) {
    console.log('error loading data', fileName, message)
  }
}
